import React, { useEffect } from 'react';

import { Autocomplete, TextField } from '@mui/material';

import Styles from '../lib/Styles';
import IState from '../shared/IState.js';
import classes from './SelectBoxedField.module.scss';
import states from './USStates.json';

export default function SelectUSStates(props: any) {
  const { selectedUSStates, setSelectedUSStates, onChangeUSStates, readOnly } = props;
  let initialValue = React.useRef(props.initialValue);
  const cx = new Styles(classes).cx;

  useEffect(() => {
    if (initialValue.current && states && selectedUSStates.length === 0) {
      let sts: Array<string> = initialValue.current.split(',').map((item: string) => item.trim());
      let selectedSts: Array<IState> = new Array<IState>();
      for (let i = 0; i < sts.length; i++) {
        let st = sts[i];
        const index = states.findIndex((item: IState) => item.name === st);
        if (index >= 0) {
          selectedSts.push(states[index]);
        }
      }
      setSelectedUSStates(selectedSts);
      initialValue.current = undefined;
    }
  }, [selectedUSStates, setSelectedUSStates])

  return (
    <div className={cx('root')}>
    <Autocomplete
    disabled={readOnly || (!states || states.length === 0)}
    multiple
    options={states}
    getOptionLabel={(option: any) => option.name}
    defaultValue={undefined}
    value={selectedUSStates}
    filterSelectedOptions
    onChange={onChangeSelectedStates}
    renderInput={(params: any) => (
      <TextField
        {...params}
        variant="outlined"
        label="States"
        placeholder={"Select one or more states."}
        fullWidth
      />
    )}
  />
    </div>
  );

  function onChangeSelectedStates(event: any, values: any) {
    setSelectedUSStates(values);
    onChangeUSStates();
  }
}
